export enum AuthorizationScreens {
  login = <any>'login',
  registration = <any>'registration',
  resetPassword = <any>'resetPassword',
  changePassword = <any>'changePassword'
}
